exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown {\n  cursor: pointer;\n  background-color: #e6e6f2;\n  height: 28px;\n  border-radius: 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/shared/hotel-dropdown/hotel-dropdown.component.scss
// module id = ../../../../../src/app/shared/hotel-dropdown/hotel-dropdown.component.scss
// module chunks = main